let accordions = document.querySelectorAll('.js-accordion');
const isMobile = !window.matchMedia('only screen and (min-width: 768px)').matches

    accordions.forEach((accordion) => {

        let open = false;

        let content = accordion.querySelector('.js-accordion-content');

        let trigger = accordion.querySelector('.js-accordion-trigger');

        let reveal = accordion.querySelector('.js-reveal span');
            // revealText = '<em>' + reveal.innerText + '</em> ' + reveal.dataset.reveal;

        function setupAnim() {
            let openAccordion = gsap.timeline({
              paused: true
            }).fromTo(content, 0.4, { height: 0 }, { height: "auto", ease: "sine.out" });

            if (reveal.dataset.reveal !== '') {
                // openAccordion.from()
                openAccordion.set(reveal, { duration: 0, display: "inline", ease: "sine.out" })
                openAccordion.fromTo(reveal, 0.4, { opacity: 0, height: 0}, { opacity: 1, height: "auto", ease: "sine.out" })
            }

            openAccordion
            .fromTo(content, 0.4, { opacity: 0 }, { opacity: 1 });

            trigger.addEventListener("click", () => {

                if (open == false) {
                    openAccordion.play();
                    // morphAnim.play();
                    open = true;
                    accordion.classList.add('active');
                } else {
                    openAccordion.reverse();
                    // morphAnim.reverse();
                    open = false;
                    accordion.classList.remove('active');
                }

            });

            if (!isMobile) {
              window.addEventListener('resize', (event) => {
                  openAccordion.invalidate();
              });
            }
        }
        setupAnim();

        if (!isMobile) {
          window.addEventListener('resize', (event) => {
              setupAnim();
          });
        }



    });
